var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.133 16.1C18.1395 14.1289 16.9379 12.3551 15.105 11.63L10.005 9.591C9.19727 9.26765 8.73262 8.4166 8.89738 7.5623C9.06214 6.70799 9.80995 6.09078 10.68 6.091H15.703C16.5314 6.091 17.203 5.41943 17.203 4.591C17.203 3.76257 16.5314 3.091 15.703 3.091H13.75C13.6119 3.091 13.5 2.97907 13.5 2.841V1.5C13.5 0.671573 12.8284 0 12 0C11.1716 0 10.5 0.671573 10.5 1.5V2.871C10.5005 3.00092 10.4014 3.10957 10.272 3.121C8.04482 3.29963 6.23542 4.99137 5.90767 7.20153C5.57992 9.4117 6.8205 11.5557 8.9 12.373L14 14.412C14.8077 14.7353 15.2724 15.5864 15.1076 16.4407C14.9429 17.295 14.195 17.9122 13.325 17.912H8.294C7.46557 17.912 6.794 18.5836 6.794 19.412C6.794 20.2404 7.46557 20.912 8.294 20.912H10.25C10.3881 20.912 10.5 21.0239 10.5 21.162V22.5C10.5 23.3284 11.1716 24 12 24C12.8284 24 13.5 23.3284 13.5 22.5V21.129C13.4995 20.9991 13.5986 20.8904 13.728 20.879C16.2133 20.669 18.1258 18.5941 18.133 16.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.fd6a6444.svg";
export { ForwardRef as ReactComponent };